/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/jsx-indent */
/* eslint-disable prettier/prettier */
import React, { useContext } from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-scroll';
import PortfolioContext from '../../context/context';
import GithubButtons from '../GithubButtons/GithubButtons';

import { githubButtons } from '../../mock/data';

const Footer = () => {
    const { footer } = useContext(PortfolioContext);
    const { networks } = footer;
    const { isEnabled } = githubButtons;

    return (
        <footer className="footer navbar-static-bottom">
            <Container>
                <span className="back-to-top">
                    <Link to="hero" smooth duration={1000}>
                        <i className="fa fa-angle-up fa-2x" aria-hidden="true" />
                    </Link>
                </span>
                <div className="social-links">
                    {networks &&
                        networks.map((network) => {
                            const { id, name, url } = network;
                            return (
                                <a
                                    key={id}
                                    href={url}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    aria-label={name}
                                >
                                    <i className={`fa fa-${name || 'refresh'} fa-inverse`} />
                                </a>
                            );
                        })}
                </div>
                {/* <hr /> */}
                {/* <p className="footer__text">
                    © {new Date().getFullYear()} - Template developed by{' '} */}
                {/* <a className="footer__text" href="https://github.com/douglasryu" target="_blank" rel="noopener noreferrer">
                    Douglas Ryu
                    </a> */}
                {/* </p> */}

                {isEnabled && <GithubButtons />}
            </Container>
        </footer>
    );
};

export default Footer;
